module.exports = __webpack_public_path__ + "static/media/cases_ident_visual_pwc_01.702e277f.jpg";